import React, { useEffect, lazy } from 'react';
import { motion } from 'framer-motion';
import { Link } from 'react-router-dom';
import { Navbar } from '../components/Navbar';
import { Footer } from '../components/Footer';
import { SEOHead } from '../components/SEOHead';
import { BreadcrumbSchema } from '../components/StructuredData';
import { ServiceNav } from '../components/ServiceNav';
export function BasicHomeCleaning() {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);
  return <div className="min-h-screen w-full font-sans bg-white flex flex-col" data-id="element-522">
      <SEOHead title="Basic Home Cleaning | Smith & Jengs Cleaning Services" description="Professional basic home cleaning services in Bicester and Oxfordshire. Flexible, affordable, and designed to meet your daily needs." canonical="https://smithandjengs.com/basic-home-cleaning" data-id="element-523" />
      <BreadcrumbSchema items={[{
      name: 'Home',
      url: 'https://smithandjengs.com/'
    }, {
      name: 'Basic Home Cleaning',
      url: 'https://smithandjengs.com/basic-home-cleaning'
    }]} data-id="element-524" />
      <Navbar data-id="element-525" />

      <main className="flex-1" data-id="element-526">
        {/* 1. Hero Banner */}
        <section className="relative w-full h-[55vh] min-h-[420px] max-h-[600px] overflow-hidden bg-[#1a2744]" data-id="element-527">
          <div className="absolute inset-0" data-id="element-528">
            <img src="https://cdn.magicpatterns.com/uploads/hALs7bhhgH38SiEkLYefJP/sj-website-basic-home-banner.png" alt="Modern clean living room" className="w-full h-full object-cover object-center" decoding="async" data-id="element-529" />
            {/* Dark gradient overlay */}
            <div className="absolute inset-0 bg-gradient-to-r from-[#1a2744]/90 via-[#1a2744]/50 to-transparent" data-id="element-530" />
            <div className="absolute inset-0 bg-gradient-to-t from-[#1a2744]/70 via-transparent to-transparent" data-id="element-531" />
          </div>

          <div className="relative z-10 h-full flex items-end px-6 md:px-12 pb-12 pt-32" data-id="element-532">
            <motion.div initial={{
            opacity: 0,
            y: 30
          }} animate={{
            opacity: 1,
            y: 0
          }} transition={{
            duration: 0.8
          }} className="max-w-7xl mx-auto w-full" data-id="element-533">
              <h1 className="font-bebas text-white leading-[0.85] tracking-wide" data-id="element-534">
                <span className="text-7xl md:text-[9rem] lg:text-[11rem] block" data-id="element-535">
                  BASIC HOME
                </span>
                <span className="font-serif-playfair italic font-normal normal-case text-[#e91e8c] text-6xl md:text-[8rem] lg:text-[10rem] block -mt-2 md:-mt-6" data-id="element-536">
                  Cleaning
                </span>
              </h1>
            </motion.div>
          </div>
        </section>

        <ServiceNav data-id="element-537" />

        {/* 2. Description + Image Section */}
        <section className="w-full bg-white py-16 md:py-24 px-6 md:px-12" data-id="element-538">
          <div className="max-w-7xl mx-auto grid grid-cols-1 lg:grid-cols-2 gap-12 lg:gap-24 items-center" data-id="element-539">
            {/* Left: Text */}
            <motion.div initial={{
            opacity: 0,
            x: -50
          }} whileInView={{
            opacity: 1,
            x: 0
          }} viewport={{
            once: true
          }} transition={{
            duration: 0.8
          }} className="flex flex-col lg:max-w-md" data-id="element-540">
              <h2 className="text-3xl md:text-4xl font-bold text-[#1a2744] mb-6 leading-tight" data-id="element-541">
                The service is
                <br data-id="element-542" />
                flexible and
                <br data-id="element-543" />
                affordable.
              </h2>
              <p className="text-sm md:text-base text-gray-600 leading-relaxed" data-id="element-544">
                It is designed to meet your daily needs and facilitate your life
                on a day to day basis. We are professionals and we will take
                care of your chores. Our representatives are dedicated to
                provide reliable and efficient services to our clients.
              </p>
            </motion.div>

            {/* Right: Image */}
            <motion.div initial={{
            opacity: 0,
            x: 50
          }} whileInView={{
            opacity: 1,
            x: 0
          }} viewport={{
            once: true
          }} transition={{
            duration: 0.8
          }} className="w-full h-[400px] lg:h-[500px] rounded-sm overflow-hidden" data-id="element-545">
              <img src="https://cdn.magicpatterns.com/uploads/5bb5rmi764n2bkspfQtkCD/sj-website-basic-home-img1.png" alt="Clean modern kitchen" className="w-full h-full object-cover" loading="lazy" decoding="async" data-id="element-546" />
            </motion.div>
          </div>
        </section>

        {/* 3. Services List Section */}
        <section className="w-full bg-white pb-16 md:pb-24 px-6 md:px-12" data-id="element-547">
          <div className="max-w-7xl mx-auto grid grid-cols-1 lg:grid-cols-2 gap-12 lg:gap-24 items-center" data-id="element-548">
            {/* Left: Image */}
            <motion.div initial={{
            opacity: 0,
            x: -50
          }} whileInView={{
            opacity: 1,
            x: 0
          }} viewport={{
            once: true
          }} transition={{
            duration: 0.8
          }} className="w-full h-[400px] lg:h-[500px] rounded-sm overflow-hidden order-2 lg:order-1" data-id="element-549">
              <img src="https://cdn.magicpatterns.com/uploads/84G2ZbMVURvjbuFpe5csPV/sj-website-basic-home-img2.png" alt="Clean living and dining room" className="w-full h-full object-cover" loading="lazy" decoding="async" data-id="element-550" />
            </motion.div>

            {/* Right: List */}
            <motion.div initial={{
            opacity: 0,
            x: 50
          }} whileInView={{
            opacity: 1,
            x: 0
          }} viewport={{
            once: true
          }} transition={{
            duration: 0.8
          }} className="flex flex-col order-1 lg:order-2" data-id="element-551">
              <ul className="flex flex-col w-full" data-id="element-552">
                {['Wipe down all appliances & surfaces', 'Vacuum/mop all rooms', 'Wipe down all light switches & door knobs', 'Make all beds'].map((item, i) => <li key={i} className="border-b border-gray-300 py-6 text-[#1a2744] text-lg md:text-xl font-medium first:pt-0" data-id="element-553">
                    {item}
                  </li>)}
              </ul>
            </motion.div>
          </div>
        </section>

        {/* 4. CTA Section */}
        <section className="w-full bg-[#f8f9fa] py-16 px-6 md:px-12" data-id="element-554">
          <motion.div initial={{
          opacity: 0,
          y: 30
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.8
        }} className="max-w-5xl mx-auto flex flex-col md:flex-row items-center justify-center gap-8 md:gap-16 text-center md:text-left" data-id="element-555">
            <h2 className="text-3xl md:text-4xl font-bold text-[#1a2744] leading-tight" data-id="element-556">
              Click <span className="text-[#e91e8c]" data-id="element-557">Book Online</span> to set
              up
              <br className="hidden md:block" data-id="element-558" /> a Basic Home Cleaning
            </h2>
            <Link to="/basic-home-cleaning-quote" className="bg-[#e91e8c] hover:bg-[#d0187c] text-white px-8 py-4 rounded-full font-semibold tracking-wide transition-colors shadow-md flex items-center gap-3 whitespace-nowrap" data-id="element-559">
              Book Online <span className="text-xl leading-none" data-id="element-560">&rarr;</span>
            </Link>
          </motion.div>
        </section>
      </main>

      <Footer data-id="element-561" />
    </div>;
}